(function () {
    'use strict';

    // @ngInject
    Services.jStorage = function jStorage($window) {
        return $window.$.jStorage;
    };

}());
